module.exports = __webpack_public_path__ + "img/close.853519c1.png";